import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "../styles/noticias.css";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Avatar,
} from "@mui/material";
import heroNoticias from "../assets/events/banner-eventos.png";
import api from "../services/api";

const ITEMS_PER_PAGE = 12;

const formatFecha = (isoDate) => {
  const fecha = new Date(isoDate);
  return fecha.toLocaleDateString("es-BO", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

export default function Eventos() {
  const navigate = useNavigate();
  const [eventos, setEventos] = useState([]);
  const [page, setPage] = useState(1);

  useEffect(() => {
    const fetchEventos = async () => {
      const res = await api.get("/eventos/");
      const data = res.data.results.map((n) => ({
        id: n.id,
        titulo: n.titulo,
        descripcion: n.descripcion,
        fecha: formatFecha(n.fecha),
        modalidad: n.modalidad,
        lugar: n.lugar,
        imagen: n.imagen,
        autores: ["ABIS La Paz"],
      }));
      setEventos(data);
    };

    fetchEventos();
  }, []);

  const destacados = eventos.slice(0, 2);
  const restantes = eventos.slice(2);

  const totalPages = Math.ceil(restantes.length / ITEMS_PER_PAGE);
  const start = (page - 1) * ITEMS_PER_PAGE;
  const paginated = restantes.slice(start, start + ITEMS_PER_PAGE);

  return (
    <div className="noticias-container">
      {/* HERO */}
      <section
        className="hero-noticias"
        style={{ backgroundImage: `url(${heroNoticias})` }}
      >
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-text">
            <h1>Espacios de Encuentro para el Desarrollo Profesional</h1>
            <p>
              A través de eventos de alcance departamental, nacional e
              internacional, ABIS La Paz impulsa la actualización técnica, la
              investigación y la cooperación entre profesionales, instituciones
              y actores del sector, contribuyendo a soluciones sostenibles en
              beneficio de la salud pública y el medio ambiente.
            </p>
          </div>
        </div>
      </section>

      <div className="noticias-content">
        {/* DESTACADAS */}
        <div className="noticias-destacadas">
          {destacados.map((evento) => (
            <Card
              key={evento.id}
              className="evento-card destacada"
              onClick={() => navigate(`/eventos/${evento.id}`)}
              sx={{ cursor: "pointer" }}
            >
              <CardMedia
                component="img"
                height="240"
                image={evento.imagen}
                alt={evento.titulo}
                loading="lazy"
              />
              <CardContent>
                <Typography variant="caption" className="categoria">
                  {evento.categoria}
                </Typography>
                <Typography variant="h6" className="titulo">
                  {evento.titulo}
                </Typography>
                <Typography variant="body2" className="descripcion">
                  {evento.descripcion}
                </Typography>
                <div className="autores-fecha">
                  <div className="autores">
                    <Avatar sx={{ width: 24, height: 24 }}>A</Avatar>
                    <span>ABIS La Paz</span>
                  </div>
                  <span className="fecha">{evento.fecha}</span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* OTRAS NOTICIAS */}
        <div className="otras-noticias">
          {paginated.map((evento) => (
            <Card
              key={evento.id}
              className="evento-card"
              onClick={() => navigate(`/eventos/${evento.id}`)}
              sx={{ cursor: "pointer" }}
            >
              <CardMedia
                component="img"
                height="180"
                image={evento.imagen}
                alt={evento.titulo}
                loading="lazy"
              />
              <CardContent>
                <Typography variant="caption" className="categoria">
                  {evento.categoria}
                </Typography>
                <Typography variant="h6" className="titulo">
                  {evento.titulo}
                </Typography>
                <Typography variant="body2" className="descripcion">
                  {evento.descripcion}
                </Typography>
                <div className="autores-fecha">
                  <div className="autores">
                    <Avatar sx={{ width: 24, height: 24 }}>A</Avatar>
                    <span>ABIS La Paz</span>
                  </div>
                  <span className="fecha">{evento.fecha}</span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* PAGINACIÓN */}
        {totalPages > 1 && (
          <div className="pagination">
            <button disabled={page === 1} onClick={() => setPage(page - 1)}>
              Anterior
            </button>

            <span>
              Página {page} de {totalPages}
            </span>

            <button
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
            >
              Siguiente
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
